var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reporting-grid-container" },
    [
      _vm.showPartialDataSetMessage
        ? _c(
            "div",
            {
              staticClass: "reporting-grid-notification--partial bg-info",
              on: { click: _vm.hidePartialDatasetNotification }
            },
            [
              _c("i", { staticClass: "fa fa-times pull-right m-t-3 m-l-5" }),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-info m-t-3 m-r-5" }),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "PARTIAL_DATA_SET_MESSAGE",
                    expression: "'PARTIAL_DATA_SET_MESSAGE'"
                  }
                ]
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("AgGridWrapper", {
        attrs: {
          "group-by": _vm.groupBy.field,
          "group-by-heirarchy": _vm.activeInsightGroupHierarchy,
          "grid-state": _vm.gridState,
          "export-data": _vm.exportData,
          "col-def-look-up": _vm.insightColumnDefLookup,
          "default-col-defs": _vm.insightColumns,
          "refresh-data": _vm.refreshGridData,
          "open-columns-tool-panel": _vm.openColumnsPanel,
          "toggle-quick-insights-panel": _vm.toggleQuickInsightsPanel,
          "initial-expand-all-groups": _vm.initialExpandAllGroups,
          "col-defs-loaded-from-api": _vm.colDefsLoadedFromAPI
        },
        on: {
          gridStateChange: _vm.onGridStateChange,
          onGridTopLevelDataLoaded: _vm.onGridTopLevelDataLoaded,
          showPartialDataNotification: _vm.showPartialDatasetNotification,
          hidePartialDataNotification: _vm.hidePartialDatasetNotification,
          cellClicked: e => _vm.$emit("cellClicked", e)
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }